import { Check, Sparkles } from 'lucide-react';
import { STEP_COPY } from '../constants';

export default function CompaniesBenefitPointers() {
  return (
    <div className="px-2 py-3 sm:px-3 sm:py-3.5">
      <p className="mb-2.5 flex items-center gap-2 text-base font-bold text-gray-900">
        <Sparkles className="h-4 w-4 shrink-0 text-emerald-600" aria-hidden="true" />
        {STEP_COPY.companies.benefitPointersHeading}
      </p>
      <ul className="space-y-2.5" aria-label="Why add companies">
        {STEP_COPY.companies.benefitPointers.map((item) => (
          <li key={item} className="flex items-start gap-2 text-xs sm:text-sm leading-snug text-gray-600">
            <Check
              className="mt-0.5 h-3.5 w-3.5 shrink-0 text-emerald-600"
              strokeWidth={2.5}
              aria-hidden="true"
            />
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}
